
import * as React from 'react';
import { BaseComponent, BaseComponentState, BaseComponentProps } from '../base/BaseComponent';
import { Star } from './Star';
import Slider from 'react-slick';
import { newI18n } from './Const';
import { getTestimonial } from 'src/utils/master-data-adapter';
export interface Testimonial {
    client: {
        name: string,
        link: string,
        avatarImage: string,
        country: string
    };
    comment: string;
    date: string;
    star: number;
    link: string;
    website: {
        name: string,
        url: string
    };
}
export interface TestimonialPanelProps extends BaseComponentProps {
    template?: "FULL-SLIDER-DARK" | "FULL-SLIDER-LIGHT" | "N-TESTI-SLIDER-LIGHT" | "N-TESTI-SLIDER-DARK" | "HALF-WITH-IMAGE";
    slideNumber?: number;
    backgroundImage?: string;
}
export interface TestimonialPanelState extends BaseComponentState {
    testimonials: Testimonial[];
}
export class TestimonialPanel extends BaseComponent<TestimonialPanelProps, TestimonialPanelState> {
    translation = {
        Title: newI18n("TESTIMONIAL.Title", "Testimonials"),
        SubTitle: newI18n("TESTIMONIAL.SubTitle", "")
    };
    constructor(props: TestimonialPanelProps) {
        super(props);
        this.state = {
            testimonials: []
        };
    }
    componentDidMount() {
        this.getData();
    }
    getData = () => {
        let testimonials: Testimonial[] = [];
        getTestimonial().then(
            t => {
                testimonials = t;
                this.setState({ testimonials });
            }
        );
        
    }

    renderFullSliderDark() {
        let testis: any[] = [];
        let txtColor = "#333";
        let loop = 0;
        for (let t of this.state.testimonials) {
            let key = `testi${loop}`;
            let avatar = "/assets/images/user-icon.png";
            if (t.client.avatarImage !== "") {
                avatar = t.client.avatarImage;
            }
            testis.push(
                <div key={key}>
                    <Star starNo={t.star} />
                    <a href={`${t.client.link}`} target="_blank">
                        <div style={{ width: 75, height: 75, borderRadius: "50%", background: `url("${avatar}")`, backgroundSize: 'cover' }} />
                        <span style={{ color: txtColor, textAlign: "center" }}>{t.client.name} - {t.client.country}</span>
                    </a>
                    <p style={{ textAlign: "center", color: txtColor }}>{t.comment}</p>
                    <p style={{ textAlign: "right", color: txtColor }}>{t.date}</p>
                    <p style={{ textAlign: "center", color: txtColor }}><a href={`${t.website.url}`} target="_blank">{t.website.name}</a></p>
                </div>
            );
        }
    }
    render() { 
        let settings: any = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
        };
        let txtColor = "#eee";
        let styles: any = { backgroundColor: '#334960' } ;
        let testiStyle: any = {};
        if (this.props.backgroundImage !== "") {
            styles = { background: `url("${this.props.backgroundImage}")`, backgroundSize: "cover", backgroundPosition: "center" };
        }
        if (this.props.template === "HALF-WITH-IMAGE") { 
            settings = {
                dots: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
            };
        } else if (this.props.template === 'FULL-SLIDER-LIGHT') {
            settings = {
                dots: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
            };
            txtColor = "#333";
        } else if (this.props.template === "N-TESTI-SLIDER-DARK") {
            settings = {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: this.props.slideNumber,
                slidesToScroll: this.props.slideNumber,
                autoplay: true,
                responsive: [{
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            };
            testiStyle = {
                border: '1px solid #f7f7f821',
                borderRadius: 5,
                margin: "0 5px",
                padding: 20, 
            };
        } else if (this.props.template === 'N-TESTI-SLIDER-LIGHT') {
            settings = {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: this.props.slideNumber,
                slidesToScroll: this.props.slideNumber,
                autoplay: true,
                responsive: [{
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            };
            txtColor = "#333";
            testiStyle = {
                border: '1px solid #f7f7f821',
                borderRadius: 5,
                margin: "0 5px",
                padding: 20, 
            };
        }
        let testis: any[] = []; 
        let lop = 0;
        for (let t of this.state.testimonials) {
            let avatar = "/assets/images/user-icon.png";
            if (t.client.avatarImage !== "") {
                avatar = t.client.avatarImage;
            }
            lop++; 
            testis.push(
                <div key={`tes-${lop}`}>
                    <div style={testiStyle}>
                    <Star starNo={t.star} /> 
                    <p style={{ textAlign: "center", color: txtColor }}>{t.comment}</p>
                    <p style={{ textAlign: "right", color: txtColor }}><a href={`${t.link}`} target="_blank">{t.date}</a> </p>
                    <p style={{ textAlign: "center", color: txtColor }}><a href={`${t.website.url}`} target="_blank">{t.website.name}</a></p>
                    <a href={`${t.client.link}`} target="_blank">
                        <div className="img-circle testimonial-thumb no-visible flipInY animated" style={{ width: 75, height: 75, borderRadius: "50%", background: `url("${avatar}")`, backgroundSize: "cover" }} />
                        <span style={{ color: txtColor }}>{t.client.name} - {t.client.country}</span>
                    </a>
                    
                </div>
                </div>
                
            );
        }
        
        return (
            <section className="container-fluid container-fullw " style={styles}>
                <div className="container">
                    <div className="">
                        <div className="col-md-12">
                            <h2 className="text-center text-white" > {this.translation.Title}</h2>
                            <hr />
                            <h4 className="text-center text-white" > {this.translation.SubTitle}</h4>
                            <div className="row testimonial-container center">
                                <div  data-appears-group-delay="0" data-appears-delay-increase="200">
                                    <div>
                                        <Slider {...settings}>
                                            {testis}
                                        </Slider>
                                    </div>  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/TestimonialPanel.tsx